 
export const REPORT_TYPES = {
    MARRIAGE: {
        id: 'MARRIAGE',
        name: 'Marriage & Love Life Report',
        description: 'Complete analysis of marriage prospects, compatibility, timing, and relationship harmony',
        icon: '',
        color: '#FF6B9D',
        credits: 50
    },
    // BUSINESS: {
    //     id: 'BUSINESS',
    //     name: 'Business & Entrepreneurship Report',
    //     description: 'Detailed business potential, partnerships, sectors, and financial growth analysis',
    //     icon: '',
    //     color: '#4CAF50',
    //     credits: 50
    // },
    // CAREER: {
    //     id: 'CAREER',
    //     name: 'Career & Professional Growth Report',
    //     description: 'Comprehensive career guidance, promotions, job changes, and success timing',
    //     icon: '',
    //     color: '#2196F3',
    //     credits: 45
    // },
    // FAMILY: {
    //     id: 'FAMILY',
    //     name: 'Family & Relationships Report',
    //     description: 'Family dynamics, parent-child bonds, sibling relationships, and domestic harmony',
    //     icon: '',
    //     color: '#FF9800',
    //     credits: 45
    // },
    // HEALTH: {
    //     id: 'HEALTH',
    //     name: 'Health & Wellness Report',
    //     description: 'Complete health analysis, disease prediction, preventive care, and wellness timing',
    //     icon: '',
    //     color: '#E91E63',
    //     credits: 45
    // },
    // FINANCIAL: {
    //     id: 'FINANCIAL',
    //     name: 'Financial & Wealth Report',
    //     description: 'Wealth accumulation, income sources, investment timing, and financial stability',
    //     icon: '',
    //     color: '#FFC107',
    //     credits: 50
    // },
    // EDUCATION: {
    //     id: 'EDUCATION',
    //     name: 'Education & Learning Report',
    //     description: 'Academic performance, study aptitude, exam success, and educational guidance',
    //     icon: '',
    //     color: '#9C27B0',
    //     credits: 40
    // },
    // SPIRITUAL: {
    //     id: 'SPIRITUAL',
    //     name: 'Spiritual & Personal Growth Report',
    //     description: 'Spiritual journey, life purpose, inner growth, and consciousness evolution',
    //     icon: '',
    //     color: '#673AB7',
    //     credits: 40
    // },
    // COMPLETE: {
    //     id: 'COMPLETE',
    //     name: 'Complete Life Analysis Report',
    //     description: 'Comprehensive analysis covering all major life areas with detailed predictions',
    //     icon: '',
    //     color: '#607D8B',
    //     credits: 100
    // },
    ANNUAL_2026: {
        id: 'ANNUAL_2026',
        name: '2026 Master Year Forecast',
        description: 'Deep, month-wise, Dasha-based 2026 life prediction using D1 & D9 with karmic insights',
        icon: '',
        color: '#3F51B5',
        credits: 0
    }
};
 